import { pm2ConfigStore } from '@pm2/store';
import { makeTanstackQuery } from '@provider/tanstack';
import { useUserIdentityState } from '@provider/user-identity';
import { configRefs, DAYS_TO_MS } from '@utils/constants';
import { getInternalKeyForLocationDescriptor } from '../util.get-internal-key.js';
import { getLocationDataRequest } from './get-data.request.js';

const getLocationDataQuery = makeTanstackQuery({
  defaultQueryConfig: {
    staleTime: 1 * DAYS_TO_MS,
    gcTime: 21 * DAYS_TO_MS,
    meta: {
      persist: true,
      revalidateOnRefresh: true
    }
  },
  queryKey: input => ["user-area/location/get-data", configRefs.env.app.dangerouslyAssertSyncValue(), input.user?.id, getInternalKeyForLocationDescriptor(input.descriptor)],
  queryFn: async input => {
    if (!input.user) {
      return null;
    }
    const res = await getLocationDataRequest(input.configStore.getState(), input.descriptor);
    return res;
  },
  useQueryInput(queryFactory, externalInput) {
    const user = useUserIdentityState(state => state.user);
    const configStore = pm2ConfigStore.useStore();
    return queryFactory({
      user,
      configStore,
      ...externalInput
    });
  }
});

export { getLocationDataQuery };
//# sourceMappingURL=get-data.query.js.map
